module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/informacje-podstawowe@3x-67a170c4.svg";